import type { EventEvolutionEvent } from "./EventEvolutionTypes";
import { EventObjectTitle } from "./EventObjectTitle";
import { getFieldText } from "./eventEvolutionUtils";

interface EventObjectPairProps {
  event?: EventEvolutionEvent;
}

export const EventObjectPair = ({ event }: EventObjectPairProps) => (
  <div className="flex min-w-0 flex-wrap items-start gap-x-2 gap-y-1 text-base">
    <EventObjectTitle
      name={getFieldText(event?.target?.spaceObject?.name ?? event?.target)}
      norad={getFieldText(
        event?.target?.spaceObject?.noradId ?? event?.targetNorad,
      )}
      cospar={getFieldText(
        event?.target?.spaceObject?.cosparId ?? event?.targetCospar,
      )}
      sourceOfInformation={getFieldText(
        event?.targetSourceOfInformation ??
          event?.target?.spaceObject?.sourceOfInformation,
      )}
      updateTime={event?.targetOrbitUpdateTime ?? event?.executionTime}
    />
    <span className="mt-1 text-xs font-semibold uppercase text-slate-400">
      vs
    </span>
    <EventObjectTitle
      name={getFieldText(event?.chaser?.spaceObject?.name ?? event?.chaser)}
      norad={getFieldText(
        event?.chaser?.spaceObject?.noradId ?? event?.chaserNorad,
      )}
      cospar={getFieldText(
        event?.chaser?.spaceObject?.cosparId ?? event?.chaserCospar,
      )}
      sourceOfInformation={getFieldText(
        event?.chaserSourceOfInformation ??
          event?.chaser?.spaceObject?.sourceOfInformation,
      )}
      updateTime={event?.chaserOrbitUpdateTime ?? event?.executionTime}
    />
  </div>
);
